import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';
import FingerprintIcon from '@material-ui/icons/Fingerprint';
import ForumIcon from '@material-ui/icons/Forum';
import Link from '@material-ui/core/Link';
import CustomerCard from '../../components/CustomerCard';
import { convertPhoneFormat } from '../../helper';
import TelegramIcon from '@material-ui/icons/Telegram';

const useStyles = makeStyles((theme) => ({
  listRoot: {
    padding: 0,
    color: '#888',
    '& .MuiListItemIcon-root': {
      minWidth: 30,
    },
    '& .MuiListItem-gutters': {
      paddingTop: 1,
      paddingBottom: 1,
    },
  },
  listName: {
    marginLeft: 5,
    textDecoration: 'underline',
  },
  contactIcon: {
    marginRight: '5px',
    fontSize: '15px',
    background: theme.palette.primary.main,
    borderRadius: '100%',
    padding: '5px',
    color: theme.palette.primary.contrastText,
  },
  contactList: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: '3px 32px',
    [theme.breakpoints.down('md')]: {
      padding: 0,
    },
  },
  wrapText: {
    wordBreak: 'break-all',
    color: '#00B8D9',
    textDecoration:'underline'
  },
  iconDisable: {
    position: 'absolute',
    left: 2.5,
    top: 2.5,
    background: '#ffffff6b',
    borderRadius: '50%',
    transform: 'rotate(-60deg)',
    opacity: 0.5,
    color: '#848b94',
    cursor: 'not-allowed',
  },
  mainBox:{
     marginBottom: 20,
     marginTop:9,
     '& h5': {
      fontWeight:700
     }
  },
  mainBox2:{
     marginTop:4
  },
  textButton:{
    padding:'5px 10px',
    borderRadius: '8px',
    marginTop: '24px',
    borderColor: 'rgba(145, 158, 171, 0.24)',
    fontWeight: 'normal',
    color: '#212B36'
  },
  customerName:{
    textDecoration:'underline'
  }
}));

const UnifiedCustomer = ({ customer, storderId, tireQty }) => {
  const { id, email, phone } = customer;
  const classes = useStyles();
  return (
    <Grid container spacing={0}>
      <Grid item xs={10} sm={10} md={10} className={classes.mainBox}>
        <Typography variant="h5" gutterBottom>
          Customer Info
        </Typography>
        
      </Grid>
      <List className={classes.listRoot}>
        {/*<CustomerCard record={{ customer }} storderId={storderId} />*/}
        <Typography variant="subtitle2" gutterBottom className={classes.customerName}>
          {customer.first_name} {customer.last_name}
        </Typography>
        <Typography>
          <Link href="javascript:;"  className={classes.wrapText}>
            {email || 'No email on file'}
          </Link>
        </Typography>
        <Typography>
          <Link href="javascript:;" className={classes.wrapText}>
            {convertPhoneFormat(phone)}
          </Link>
        </Typography>
        {/*<ListItem>
          <ListItemIcon>
            <FingerprintIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText> {id}</ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <ForumIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText> Contact Method Preference</ListItemText>
        </ListItem>*/}
      </List>
      {/*<Grid item xs={12} sm={12} md={12} className={classes.mainBox2}>
        <Box>
          <Button
            variant="outlined"
            className={classes.textButton}
          >
          Text
          <svg style={{ paddingLeft: '0.5em' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M1.09349 6.33079C0.622759 6.65254 0.604763 7.25761 1.03368 7.63332C1.60744 8.13588 2.6034 8.94908 4.28845 10.187C4.28846 10.1853 4.28847 10.1845 4.28847 10.1845C4.98679 8.71843 13.7139 1.62479 14.0888 1.99979C14.4595 2.37048 9.32629 9.21549 7.13318 12.0923C7.08192 12.1595 7.04513 12.2302 7.01824 12.3103C6.81544 12.9152 5.87987 15.6237 5.3253 15.8162C6.51124 15.5876 7.69192 14.6391 8.78607 13.329C10.1741 14.2454 11.1567 14.8354 11.7539 15.178C12.1718 15.4176 12.6844 15.3286 12.904 14.8999C14.1724 12.4246 15.6017 5.08939 15.8705 1.24652C15.9139 0.626718 15.4117 0.13056 14.8005 0.242388C10.9952 0.938666 3.69786 4.55048 1.09349 6.33079Z" fill="#00A76F"/>
            <path d="M5.26538 15.827C5.26536 15.827 5.2654 15.827 5.26538 15.827V15.827Z" fill="#00A76F"/>
            <g style="mix-blend-mode:overlay" filter="url(#filter0_i_629_7231)">
              <path d="M1.09349 6.33079C0.622759 6.65254 0.604763 7.25761 1.03368 7.63332C1.60744 8.13588 2.6034 8.94908 4.28845 10.187C4.28846 10.1853 4.28847 10.1845 4.28847 10.1845C4.98679 8.71843 13.7139 1.62479 14.0888 1.99979C14.4595 2.37048 9.32629 9.21549 7.13318 12.0923C7.08192 12.1595 7.04513 12.2302 7.01824 12.3103C6.81544 12.9152 5.87987 15.6237 5.3253 15.8162C6.51124 15.5876 7.69192 14.6391 8.78607 13.329C10.1741 14.2454 11.1567 14.8354 11.7539 15.178C12.1718 15.4176 12.6844 15.3286 12.904 14.8999C14.1724 12.4246 15.6017 5.08939 15.8705 1.24652C15.9139 0.626718 15.4117 0.13056 14.8005 0.242388C10.9952 0.938666 3.69786 4.55048 1.09349 6.33079Z" fill="white" fill-opacity="0.08"/>
              <path d="M5.26538 15.827C5.26536 15.827 5.2654 15.827 5.26538 15.827V15.827Z" fill="white" fill-opacity="0.08"/>
            </g>
            <defs>
              <filter id="filter0_i_629_7231" x="-1.27441" y="-1.77344" width="17.1475" height="17.6006" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                <feOffset dx="-2" dy="-2"/>
                <feGaussianBlur stdDeviation="2"/>
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"/>
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_629_7231"/>
              </filter>
            </defs>
          </svg>
          </Button>
        </Box>
      </Grid>*/}
    </Grid>
  );
};

export default UnifiedCustomer;
